import { Directive, ElementRef, Renderer2 } from '@angular/core';
@Directive({
    selector: '[fullHeight]'
})
export class fullHeightDirective {
    private _el:HTMLElement;
    constructor(el: ElementRef,private renderer: Renderer2) {
      this._el = el.nativeElement;
    }
  
    ngOnInit(): void {
        this.renderer.setStyle(this._el, 'height', window.innerHeight+'px');
    }
}


// WEBPACK FOOTER //
// ./src/directives/fullHeight.ts